import React, { useState, useRef } from "react";
import { AmountFormat, DateFormat } from "components/common/formatter";
import { gearIcon, printIcon } from "@progress/kendo-svg-icons";
import { Popup } from "@progress/kendo-react-popup";
import { Checkbox } from "@progress/kendo-react-inputs";
import { SvgIcon } from "@progress/kendo-react-common";
import previousIcon from "assets/previous-icon.png";
import excelIcon from "assets/fileIcons/Excel.svg";
import { Loader } from "@progress/kendo-react-indicators";
import styles from "./LedgerGrid.module.scss";

export const getLedgerCellValue = (
  amount,
  method,
  options = { checkMillion: true }
) => {
  if (isNaN(amount)) {
    return "";
  }
  if (method === "Credit" && amount < 0) {
    return AmountFormat(Math.abs(amount), options);
  }
  if (method === "Debit" && amount > 0) {
    return AmountFormat(Math.abs(amount), options);
  }
  if (method === "Amount") {
    return AmountFormat(amount);
  }
  return "";
};

export const cellWithBackGround = (props, type, method) => {
  const style = { background: "", opacity: 1 };

  if (type === "CLIENT") {
    style.background =
      "linear-gradient(180deg, #ECECEC 0%, rgba(190, 190, 190, 0.12) 100%)";
  } else if (type === "DDA") {
    style.background = "linear-gradient(180deg, #D7D7D7 0%, #EAEAEA 100%)";
  } else if (type === "OFFICE") {
    style.background =
      "linear-gradient(180deg, #FAFAFA 0%, rgba(225, 225, 225, 0.12) 100%)";
  }

  const amount = props.dataItem[props.field];
  const options =
    method === "Amount" ? { checkMillion: false } : { checkMillion: true };

  return (
    <td style={style} className="text-end bg-none">
      <span style={{ opacity: "0.95", background: "none" }}>
        {getLedgerCellValue(amount, method, options)}
      </span>
    </td>
  );
};

export const CenterTextHeaderCell = (props) => (
  <span
    className="d-flex pb-2 justify-content-center"
    style={{ color: "#000000", fontSize: "13px", fontWeight: "700" }}
  >
    {props.title}
  </span>
);

export const RefCell = (props, handleActionRef) => {
  return (
    <td
      style={{ cursor: props.isPrevTrans ? "default" : "pointer" }}
      onClick={(event) => {
        if (!props.isPrevTrans && handleActionRef) {
          handleActionRef(event, props.dataItem.transactionNo);
        }
      }}
    >
      <u>{props.dataItem.reference}</u>
    </td>
  );
};

export const SettingsHeaderCell = (props) => {
  const anchor = useRef(null);
  const [showPopup, setShowPopup] = useState(false);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const closePopup = () => {
    setShowPopup(false);
  };
  return (
    <th {...props.headerProps}>
      <div
        style={{
          marginLeft: "-30px",
        }}
      >
        <span ref={anchor} onClick={togglePopup} style={{ cursor: "pointer" }}>
          <button
            className={`${styles["dark-background"]} border-0`}
            title="Settings"
          >
            <SvgIcon icon={gearIcon} size="default" color="gray" />
          </button>
        </span>
      </div>
      {showPopup && (
        <Popup
          anchor={anchor.current}
          show={showPopup}
          onClose={closePopup}
          popupAlign={{ horizontal: "right", vertical: "top" }}
          anchorAlign={{ horizontal: "right", vertical: "bottom" }}
          onMouseDownOutside={closePopup}
        >
          <div className="p-3">
            <Checkbox
              checked={props.showDDAValue}
              onChange={props.onToggleDDA}
              label="Show DDA Account"
            />
            <div className="mt-2 d-flex align-items-center">
              <Checkbox
                checked={props.showReversalsValue}
                onChange={props.onToggleShowReversals}
                label="Show Reversals"
              />
            </div>
          </div>
        </Popup>
      )}
    </th>
  );
};

export const ToolbarHeaderCell = ({
  matterId,
  isClosed,
  dateClosed,
  closedByUserRef,
  onPrint,
  onShowPrevTrans,
  isExporting,
  exportReport,
}) => (
  <div className="d-flex gap-3 align-items-center  px-2">
    <button
      className="btn p-0 border-0"
      onClick={onPrint}
      title="Print"
      disabled={!matterId}
    >
      <div className={`${styles["dark-background"]}`}>
        <SvgIcon icon={printIcon} size="default" color="blue" />
      </div>
    </button>

    <button
      className="btn p-0 border-0"
      onClick={() => exportReport(false)}
      title="Export to Excel"
      disabled={!matterId || isExporting}
    >
      <div className={`${styles["dark-background"]}`}>
        {isExporting ? (
          <Loader size="small" type="infinite-spinner" className="text-dark" />
        ) : (
          <img src={excelIcon} width={18} height={18} alt="Export to Excel" />
        )}
      </div>
    </button>

    <button
      className="btn p-0 border-0"
      onClick={onShowPrevTrans}
      title="Previous Transactions"
      disabled={!matterId}
    >
      <div className={`${styles["dark-background"]}`}>
        <img src={previousIcon} width={15} height={15} alt="Prev" />
      </div>
    </button>

    {isClosed && (
      <div className={`d-flex align-items-center gap-2 ms-2 ${styles["closed-banner"]}`}>
        <div className={`${styles["close-button"]}`} />
        <span className="fs-md fw-semibold">
          Closed
          {dateClosed && (
            <span className="fw-normal"> on {DateFormat(dateClosed)}</span>
          )}
          {closedByUserRef && (
            <span className="fw-normal"> by '{closedByUserRef}'</span>
          )}
        </span>
      </div>
    )}
  </div>
);
